import { Bookmark, ThumbsDown, ThumbsUp, X } from "lucide-react";

const BUTTONS = {
  left: { icon: X, label: "Pass", cls: "text-[hsl(var(--sp-left))] hover:bg-[hsl(var(--sp-left)/0.12)]" },
  down: { icon: ThumbsDown, label: "Seen · nah", cls: "text-[hsl(var(--sp-down))] hover:bg-[hsl(var(--sp-down)/0.12)]" },
  up: { icon: ThumbsUp, label: "Seen · liked", cls: "text-[hsl(var(--sp-up))] hover:bg-[hsl(var(--sp-up)/0.12)]" },
  right: { icon: Bookmark, label: "Watchlist", cls: "text-[hsl(var(--sp-right))] hover:bg-[hsl(var(--sp-right)/0.12)]" },
};

export const SwipeActions = ({ onAction, order = ["left", "down", "up", "right"], disabled }) => (
  <div className="flex items-start justify-center gap-4 sm:gap-6" data-testid="swipe-actions">
    {order.map((dir) => {
      const { icon: Icon, label, cls } = BUTTONS[dir];
      return (
        <div key={dir} className="flex flex-col items-center gap-1.5">
          <button onClick={() => onAction(dir)} disabled={disabled} data-testid={`swipe-button-${dir}`} aria-label={label}
            className={`h-14 w-14 sm:h-16 sm:w-16 rounded-full border bg-card shadow-lg flex items-center justify-center transition-[transform,background-color] duration-200 hover:scale-110 active:scale-95 disabled:opacity-40 ${cls}`}>
            <Icon className="h-6 w-6" strokeWidth={2.5} />
          </button>
          <span className="text-[10px] uppercase tracking-widest text-muted-foreground font-semibold">{label}</span>
        </div>
      );
    })}
  </div>
);
